import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";

class Input extends React.Component {
    constructor(props) {
        super(props);
        props.input.value = props.input.value || "";
    }

    render() {
        return (
            <input autoFocus={this.props.autoFocus} onFocus={this.props.onFocus} type={this.props.input.type} value={this.props.input.value}
                   disabled={this.props.input.disabled} id={this.props.input.id}
                   placeholder={this.props.input.placeholder} required={this.props.input.required}
                   title={this.props.input.title}
                   onChange={this.props.onChange} onBlur={this.props.onBlur}/>
        )
    }
}

export const InputGroup = WrapperInputGroup(Input);

InputGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/input/base/InputGroup.js